/* eslint-disable no-console */
import { Component, HostListener } from '@angular/core';
import { SideBar2Const, sideBarTutor1, sideBarTutor2 } from '../../core/constants/sidebar.const';
import { AuthService } from '../../services/auth.service';
import { UserRole } from '../../core/constants/keys.constant';
import { SocketService } from '../../services/socket.service';
import { Subject, takeUntil } from 'rxjs';
import { dashboardNotification, UserResponse } from '../../models/auth.model';
import { SideBar } from '../../models/sideBar.model';

@Component({
  selector: 'mindbase-tutor-sidebar',
  templateUrl: './tutor-sidebar.component.html',
  styleUrl: './tutor-sidebar.component.scss'
})
export class TutorSidebarComponent {
  public sideBar = sideBarTutor1;
  public sideBar2 = sideBarTutor2;
  protected SideBar2Const = SideBar2Const;
  protected UserRole = UserRole;
  public innerWidth = 0;
  public sidenavWidth = 5;
  public chatNotificationCount: number | undefined = 0;
  protected destroy : Subject<boolean> = new Subject<boolean>();
  /** Gates "Knowledge Bank" / "Student Progress" / "AI Counselor" nav items (admin: Instructor Permissions → AI Tutor). */
  protected canAccessKnowledgeBank = true;
  protected canAccessStudentProgress = true;
  protected canAccessAiCounselor = true;
  constructor(public _authService: AuthService, private _socketService: SocketService) {
    this.getChatCount();
    this.chatCountUpdated();
    this.clearNotifications();
    this._authService.profileDetailsSubject
      .pipe(takeUntil(this.destroy))
      .subscribe((res: UserResponse | null) => {
        if (res !== null && (res.role === UserRole.TUTOR || res.role === UserRole.COUNSELOR)) {
          this.canAccessKnowledgeBank =
            res.instructorPermissions?.instructor.aiTutor?.canAccessKnowledgeBank ?? false;
          this.canAccessStudentProgress =
            res.instructorPermissions?.instructor.aiTutor?.canAccessStudentProgress ?? false;
          this.canAccessAiCounselor =
            res.instructorPermissions?.instructor.aiTutor?.canAccessAiCounselor ?? false;
        }
      });
    this._authService.permissionUpdate
      .pipe(takeUntil(this.destroy))
      .subscribe((res: any) => {
        if (res !== null) {
          this.canAccessKnowledgeBank = res.instructor?.aiTutor?.canAccessKnowledgeBank ?? false;
          this.canAccessStudentProgress = res.instructor?.aiTutor?.canAccessStudentProgress ?? false;
          this.canAccessAiCounselor = res.instructor?.aiTutor?.canAccessAiCounselor ?? false;
        }
      });
  }

  /** Hides nav items whose feature permission is off (admin: Instructor Permissions → AI Tutor). */
  protected isSidebarItemHidden(item: SideBar): boolean {
    if (item.path === '/tutor/ai-tutor') {
      return !this.canAccessKnowledgeBank;
    }
    if (item.path === '/tutor/student-progress') {
      return !this.canAccessStudentProgress;
    }
    if (item.path === '/tutor/ai-counselor') {
      return !this.canAccessAiCounselor;
    }
    return false;
  }
  increase(): void {
    this.sidenavWidth = 15;
  }
  decrease(): void {
    this.sidenavWidth = 4;
  }
  @HostListener('window', ['$event'])
  toggleSidenav(): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 1199.98) {
      this._authService.toggleSidebarView();
    }
  }

  protected clearNotifications(): void {
    this._authService.chatClicked.subscribe((res:any) => {
      if (res) {
        this.chatNotificationCount = 0;
      }
    });
  }

  protected getChatCount(): void {
    this._authService
      .getChatCount()
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (res: dashboardNotification) => {
          this.chatNotificationCount = res.receiverChatCount;
        }
      });
  }

  private chatCountUpdated(): void {
    this._socketService.onEvent('chatCountUpdated').subscribe({
      next: (res:any) => {
        this.chatNotificationCount = res.data;
      }
    });
  }
}
